import { render, staticRenderFns } from "./Ecg.vue?vue&type=template&id=74f79b93&scoped=true"
import script from "./Ecg.vue?vue&type=script&lang=js"
export * from "./Ecg.vue?vue&type=script&lang=js"
import style0 from "./Ecg.vue?vue&type=style&index=0&id=74f79b93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f79b93",
  null
  
)

export default component.exports